import { type FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import { StyledHeaderContainer, StyledHeaderText } from './styles/styled-components';

const BreakoutRoomOptionsHeader: FunctionComponent = () => {
    const { t } = useTranslation('breakout_room');
    return (
        <StyledHeaderContainer>
            <StyledHeaderText>{t('Breakout-Rooms')}</StyledHeaderText>
        </StyledHeaderContainer>
    );
};

export default BreakoutRoomOptionsHeader;
